import { Statistic } from '../components/StockTable';

// Performance statistics configuration (single Returns category)
export const PERFORMANCE_STATISTICS: Statistic[] = [
  { key: 'ytd_return', label: 'Year-To-Date' },
  { key: 'one_m_return', label: '1-Month' },
  { key: 'three_m_return', label: '3-Month' },
  { key: 'six_m_return', label: '6-Month' },
  { key: 'nine_m_return', label: '9-Month' },
  { key: 'one_y_return', label: '1-Year' },
  { key: 'two_y_return', label: '2-Year' },
  { key: 'three_y_return', label: '3-Year' },
  { key: 'four_y_return', label: '4-Year' },
  { key: 'five_y_return', label: '5-Year' },
];

export const CATEGORY_HEADERS = [{ startIndex: 0, label: 'Returns' }];

export interface PerformanceRow {
  ticker_basics_id: number;
  date: string | null;
  ytd_return: number | null;
  one_m_return: number | null;
  three_m_return: number | null;
  six_m_return: number | null;
  nine_m_return: number | null;
  one_y_return: number | null;
  two_y_return: number | null;
  three_y_return: number | null;
  four_y_return: number | null;
  five_y_return: number | null;
}

export interface TickerPerformanceData {
  [tickerSymbol: string]: {
    performance: PerformanceRow | null;
  };
}

export const formatPercent = (value: number, decimals: number = 1): string => {
  return `${(value * 100).toFixed(decimals)}%`;
};

